import { defaultTo } from "lodash";
import { DateTime } from "luxon";
import { IModel, Model, ModelRecord } from "./Model";

export interface IClinicTaskAssigneeListingModel extends IModel {
    clinicTaskAssigneeId: number;
    clinicTaskId: number;
    dateCreated: string;
    authRoleId: number | undefined;
    userId: number | undefined;
    roleName: string | undefined;
    userFirstName: string | undefined;
    userLastName: string | undefined;
    userTitle: string | undefined;
}

export class ClinicTaskAssigneeListingModel extends Model implements ModelRecord<IClinicTaskAssigneeListingModel>
{
    clinicTaskAssigneeId: number;
    clinicTaskId: number;
    dateCreated: DateTime;
    authRoleId: number | undefined;
    userId: number | undefined;
    roleName: string | undefined;
    userFirstName: string | undefined;
    userLastName: string | undefined;
    userTitle: string | undefined;

    constructor(params: Partial<IClinicTaskAssigneeListingModel>) {
        super(params);
        this.clinicTaskAssigneeId = defaultTo(params.clinicTaskAssigneeId, 0)
        this.clinicTaskId = defaultTo(params.clinicTaskId, 0)
        this.dateCreated = DateTime.fromISO(defaultTo(params.dateCreated, "2000-01-01"), { zone: "utc" });
        this.authRoleId = defaultTo(params.authRoleId, undefined)
        this.userId = defaultTo(params.userId, undefined)
        this.roleName = defaultTo(params.roleName, undefined)
        this.userFirstName = defaultTo(params.userFirstName, undefined)
        this.userLastName = defaultTo(params.userLastName, undefined)
        this.userTitle = defaultTo(params.userTitle, undefined)
    }
}
